import { useState, useRef, useEffect } from "react";
import Select from "react-select";
import FilterIcon from "../assets/images/filter.png";
import ResetIcon from "../assets/images/ResetWeekIcon.png";

const MyTimesheetFilters = (props) => {
  const {
    allCrews,
    userOptions,
    filterFields,
    setFilterFields,
    filterLoading,
  } = props;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [crewNumberOptions, setCrewNumberOptions] = useState([]);
  const dropdownRef = useRef(null);

  // const [filterFields, setFilterFields] = useState({
  //   foreman: "",
  //   general_foreman: "",
  //   virtual_id: "",
  // });


  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const fetchCrewNumbers = () => {
    const crewNumbers = allCrews?.map((ele) => ({
      label: ele?.virtual_id,
      value: ele,
    }));
    setCrewNumberOptions(crewNumbers);
  };

  const onClickClear = () => {
    setFilterFields({
      foreman: "",
      general_foreman: "",
      virtual_id: "",
    });
  };

  const handleOnChange = async (item, e) => {
    const name = e?.name;
    setFilterFields((prevState) => ({
      ...prevState,
      [name]: item?.label,
    }));
  };

  useEffect(() => {
    fetchCrewNumbers();
  }, [allCrews]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="filter-container position-relative" ref={dropdownRef}>
      <button
        className="btn btn-secondary filter-button"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        Filters
        <img className="filter-icon" src={FilterIcon} alt="" />
        {(filterFields?.foreman ||
          filterFields?.general_foreman ||
          filterFields?.virtual_id) && (
          <img
            onClick={() => onClickClear()}
            src={ResetIcon}
            className="date-range-picker__cancel-icon"
            alt="eyeIcon"
          />
        )}
      </button>
      {isDropdownOpen && (
        <div className="dropdown-menu dropdown-menu-custom shadow-lg">
          <h5 className="text-center dropdown-header">Filter Options</h5>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              Foreman
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.foreman,
                  value: filterFields.foreman,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="foreman"
                options={userOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              Gen Foreman
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.general_foreman,
                  value: filterFields.general_foreman,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="general_foreman"
                options={userOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              Crew Number
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.virtual_id,
                  value: filterFields.virtual_id,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="virtual_id"
                options={crewNumberOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="button-container d-flex justify-content-between">
            <button
              type="button"
              className="date-range-picker__button primary-btn-less-width"
              onClick={onClickClear}
            >
              Clear
            </button>
            {filterLoading && (
            <div className="ddd d-flex justify-content-center align-items-center">
              <div className="spinner-border" role="status"></div>
            </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MyTimesheetFilters;
